import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '@/components/home'
import exhibitorsList from '@/components/exhibitorsList'
import exhibits from '@/components/exhibits'
import exhibitorsDetail from '@/components/exhibitorsDetail'
import exhibitsDetail from '@/components/exhibitsDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      name: 'home',
      component: home
    },
    {
      path: '/exhibitorsList',
      name: 'exhibitorsList',
      component: exhibitorsList
    },
    {
      path: '/exhibits',
      name: 'exhibits',
      component: exhibits
    },
    {
      path: '/exhibitorsDetail',
      name: 'exhibitorsDetail',
      component: exhibitorsDetail
    },
    {
      path: '/exhibitsDetail',
      name: 'exhibitsDetail',
      component: exhibitsDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js